<div class="flex flex-row gap-4">
  <div class="flex-1 flex flex-col gap-4">
    <div class="card shadow-sm">
      <div class="card-body p-3 gap-2">
        <div class="type-section-title">Visuals</div>

        <div class="form-control">
          <label class="label label-option">
            <span class="label-text">
              UI Scale
              <app-icon
                name="gameHelp"
                size="inline"
                class="text-lighter"
                [tp]="'Scales the world screen overlays and the main panels. They will automatically grow in size on resolutions beyond 1920x1080.'"
                [tpPlacement]="'top'"
              />
            </span>
            <ng-select
              [items]="uiScaleChoices"
              bindLabel="label"
              bindValue="value"
              [clearable]="false"
              [searchable]="false"
              [(ngModel)]="uiScale"
              (ngModelChange)="setOption('uiScale', $event)"
            ></ng-select>
          </label>
        </div>

        <div class="form-control">
          <label class="label label-option">
            <span class="label-text">
              Map Zoom
              <app-icon
                name="gameHelp"
                size="inline"
                class="text-lighter"
                [tp]="'Zooms in on the map view only. Does not affect the rest of the UI. Use UI Scale for that!'"
                [tpPlacement]="'top'"
              />
            </span>
            <ng-select
              [items]="mapZoomChoices"
              bindLabel="label"
              bindValue="value"
              [clearable]="false"
              [searchable]="false"
              [(ngModel)]="mapZoom"
              (ngModelChange)="setOption('mapZoom', $event)"
            ></ng-select>
          </label>
        </div>

        <div class="form-control">
          <label class="label cursor-pointer label-option">
            <span class="label-text">Clean Font</span>
            <input
              type="checkbox"
              [checked]="getOption('cleanFont')"
              class="checkbox"
              (click)="setOption('cleanFont', !getOption('cleanFont'))"
            />
          </label>
        </div>

        <div class="form-control">
          <label class="label cursor-pointer label-option">
            <span class="label-text">
              Colorblind-Friendly
              <app-icon
                name="gameHelp"
                size="inline"
                class="text-lighter"
                [tp]="'Replaces red/green color pairs (difficulty, map clear markers, success/failure, gains/losses, combat log health) with a palette chosen to stay distinguishable with common types of color blindness. Helps with protanopia, deuteranopia, and tritanopia.'"
                [tpPlacement]="'top'"
              />
            </span>
            <input
              type="checkbox"
              [checked]="getOption('colorblindMode')"
              class="checkbox"
              (click)="
                setOption('colorblindMode', !getOption('colorblindMode'))
              "
            />
          </label>
        </div>
      </div>
    </div>

    <div class="card shadow-sm">
      <div class="card-body p-3 gap-2">
        <div class="type-section-title">Motion</div>

        <div class="form-control">
          <label class="label label-option">
            <span class="label-text">
              Reduce Motion
              <app-icon
                name="gameHelp"
                size="inline"
                class="text-lighter"
                [tp]="'Removes sliding, bouncing, shaking and looping animations. Fades and highlights stay as-is. Follow System uses the reduce motion setting from your operating system.'"
                [tpPlacement]="'top'"
              />
            </span>
            <ng-select
              [items]="motionChoices()"
              bindLabel="label"
              bindValue="value"
              [clearable]="false"
              [searchable]="false"
              [(ngModel)]="motionPreference"
              (ngModelChange)="setOption('motionPreference', $event)"
            ></ng-select>
          </label>
        </div>
      </div>
    </div>
  </div>
</div>
